export default "__VITE_ASSET__CWGpF5DH__"